import { WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from 'src/reducers';
import { isMobile } from 'src/utils/MobileCheck';
const styles = (theme: Theme) =>
	createStyles({
		frame: {
			display: 'inline-flex',
			overflow: 'auto !important',
			width: '100%',
			['-webkit-overflow-scrolling']: 'touch !important',
		},
	});

class QuickModeTextPreview extends React.Component<IProps> {
	protected elmIframe: React.RefObject<HTMLIFrameElement>;
	protected elmParent: React.RefObject<HTMLDivElement>;
	protected resizeFrameWrapper: () => void;
	public constructor(props: IProps) {
		super(props);
		this.elmIframe = React.createRef();
		this.elmParent = React.createRef();
	}

	public componentDidMount() {
		if (!this.props.currentItem) {
			return;
		}
		this.loadContent();
	}

	public shouldComponentUpdate(nextProps: IProps) {
		if (!nextProps.currentItem || !this.props.currentItem) {
			return false;
		}
		if (nextProps.currentItem.page !== this.props.currentItem.page) {
			return true;
		}
		return false;
	}

	public componentWillUpdate(nextProps: IProps) {
		if (!this.props.currentItem) {
			return;
		}
		if (
			nextProps.currentItem &&
			this.props.currentItem.page === nextProps.currentItem.page
		) {
			return;
		}
	}

	public componentDidUpdate(prevProps: IProps) {
		if (!prevProps.currentItem || !this.props.currentItem) {
			return;
		}
		if (this.props.currentItem.page !== this.props.currentItem.page) {
			this.loadContent();
			return;
		}
	}

	public componentWillUnmount() {
		if (!this.props.currentItem) {
			return;
		}
		if (this.resizeFrameWrapper) {
			const type = isMobile() ? 'orientationchange' : 'resize';
			window.removeEventListener(type, this.resizeFrameWrapper);
		}
	}

	public render() {
		const { classes, currentItem, text } = this.props;
		if (text.length === 0 || !currentItem) {
			return <React.Fragment />;
		}
		return (
			<div className={classes.frame} ref={this.elmParent}>
				<iframe
					ref={this.elmIframe}
					frameBorder="0"
					title="QuickMode"
					name="QuickMode"
					src={text[currentItem.page].htmlFile.htmlUrl}
				/>
			</div>
		);
	}

	protected loadContent() {
		if (!this.elmIframe.current) {
			return;
		}
		const iframe = this.elmIframe.current;
		if (!iframe.onload) {
			iframe.onload = () => {
				this.resizeFrame();
				if (!this.resizeFrameWrapper) {
					this.resizeFrameWrapper = () => {
						this.resizeFrame();
					};
					const type = isMobile() ? 'orientationchange' : 'resize';
					window.addEventListener(type, this.resizeFrameWrapper);
				}
			};
		}
	}

	protected resizeFrame() {
		const innerHeight =
			window.innerHeight || document.documentElement.clientHeight;
		if (!(this.elmParent.current && this.elmIframe.current)) {
			return;
		}
		const rect = this.elmIframe.current.getBoundingClientRect();
		this.elmIframe.current.width = this.elmParent.current.offsetWidth.toString();
		this.elmIframe.current.height = (
			innerHeight -
			(rect.top - window.pageYOffset) -
			8
		).toString();
	}
}
const mapStateToProps = (state: IRootState) => ({
	currentItem: state.quickModeContents.currentItem,
	text: state.quickModeContents.text,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	//
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles>;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeTextPreview);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModeTextPreview.tsx